export const url = {
  apiUrl: process.env.REACT_APP_API_URL,
  socketUrl: process.env.REACT_APP_WS_URL,
};
